<template>
	<v-card flat>
		<v-card-title>Comparta su ubicación</v-card-title>
		<v-card-text>
			<v-text-field
				id="pac-input"
				type="text"
				placeholder="Acerque el mapa a una ubicación conocida."
				outlined
				dense
				filled
			>
			</v-text-field>
			<v-card-text class="py-0 left caption">
				<small>Selecione un punto en el mapa</small>
			</v-card-text>
			<div id="map" style="height: 280px;"></div>
		</v-card-text>
		<v-card-text class="py-0">
			<small>Última actualización {{ formatDate }}</small>
		</v-card-text>
		<v-card-text v-if="!hasChanged" class="py-0 caption">
			<small>Debe presionar alguna parte del mapa para poder actualizar</small>
		</v-card-text>
		<v-card-text v-if="hasChanged" class="py-0 caption">
			<small>LAT/LNG: {{ marker.position }}</small>
		</v-card-text>

		<v-card-actions>
			<v-spacer />
			<v-btn
				v-if="isMobile && currentRoute !== '/geolocation'"
				small
				text
				color="primary"
				@click="close"
			>
				Cancelar
			</v-btn>
			<v-btn
				:disabled="!hasChanged"
				:text="isMobile"
				small
				color="success"
				:loading="loading"
				@click="onsubmit"
			>
				{{ person.geolocation ? 'Actualizar ubicacion' : 'Guardar nueva ubicación' }}
			</v-btn>
		</v-card-actions>
	</v-card>
</template>

<script>
import moment from 'moment';
import icon from '@/assets/icon.png';

export default {
	props: {
		person: { type: Object, default: null },
		close: { type: Function, default: () => null },
		save: { type: Function, required: true },
		token: { type: String, default: '' },
		geofence: { type: Array, default: () => [] },
		placeName: { type: String, default: '' },
	},
	data() {
		return {
			map: null,
			marker: null,
			loading: false,
			hasChanged: false,
			polygons: null,
			isInside: false,
		};
	},
	computed: {
		currentRoute() {
			return this.$route.path;
		},
		formatDate() {
			if (this.person && this.person.geolocation)
				return moment(this.person.geolocation.date).fromNow();
			return '';
		},
	},
	mounted() {
		setTimeout(() => {
			this.initMap().then(this.setPoligon());
		}, 200);
	},
	methods: {
		async initMap() {
			const latLng = this.person.geolocation
				? {
						lat: this.person.geolocation.coordinates[0],
						lng: this.person.geolocation.coordinates[1],
				  }
				: { lat: -33.4533107, lng: -70.6633059 };
			// eslint-disable-next-line no-undef
			this.map = new google.maps.Map(document.getElementById('map'), {
				center: latLng,
				zoom: 12,
				streetViewControl: false,
				fullscreenControl: false,
				mapTypeId: 'roadmap',
				scrollwheel: true,
			});

			// Create the search box and link it to the UI element.
			const input = document.getElementById('pac-input');

			// eslint-disable-next-line no-undef
			const searchBox = new google.maps.places.SearchBox(input);
			if (this.person.geolocation)
				this.setMarker({
					latLng: {
						lat: this.person.geolocation.coordinates[0],
						lng: this.person.geolocation.coordinates[1],
					},
				});

			// Bias the SearchBox results towards current map's viewport.
			this.map.addListener('bounds_changed', () => {
				searchBox.setBounds(this.map.getBounds());
			});

			// eslint-disable-next-line no-undef
			google.maps.event.addListener(this.map, 'click', event => {
				if (this.marker) this.marker.setMap(null);
				this.setMarker(event);
				this.hasChanged = true;
			});

			// Listen for the event fired when the user selects a prediction and retrieve
			// more details for that place.
			searchBox.addListener('places_changed', () => {
				const places = searchBox.getPlaces();

				if (places.length == 0) {
					return;
				}

				// For each place, get the icon, name and location.
				// eslint-disable-next-line no-undef
				const bounds = new google.maps.LatLngBounds();
				places.forEach(place => {
					if (!place.geometry) {
						console.log('Returned place contains no geometry');
						return;
					}

					if (place.geometry.viewport) {
						// Only geocodes have viewport.
						bounds.union(place.geometry.viewport);
					} else {
						bounds.extend(place.geometry.location);
					}
				});
				this.map.fitBounds(bounds);
			});
		},
		setMarker(e) {
			// eslint-disable-next-line no-undef
			this.marker = new google.maps.Marker({
				position: e.latLng,
				label: 'Yo',
				draggable: true,
				map: this.map,
			});
			this.marker.setMap(this.map);
			// eslint-disable-next-line no-undef
			google.maps.event.addListener(this.marker, 'dragend', event => {
				if (this.marker) this.marker.setMap(null);
				this.setMarker(event);
				this.hasChanged = true;
			});
			this.isInside = false;
			if (Boolean(this.marker.position) && Boolean(this.polygons))
				// eslint-disable-next-line no-undef
				this.isInside = google.maps.geometry.poly.containsLocation(
					this.marker.position,
					this.polygons
				);
		},
		async onsubmit() {
			this.loading = true;
			const data = {
				_id: this.person._id,
				geolocation: {
					coordinates: [this.marker.getPosition().lat(), this.marker.getPosition().lng()],
					date: new Date(),
				},
			};
			await this.save(data, this.isInside);
			this.loading = false;
			this.currentRoute !== '/geolocation' && this.close();
		},
		setPoligon() {
			if (this.geofence.length) {
				// eslint-disable-next-line no-undef
				this.polygons = new google.maps.Polygon({
					paths: this.geofence,
					editable: false,
					strokeColor: '#FF0000',
					strokeOpacity: 0.8,
					strokeWeight: 2,
					fillColor: '#FF0000',
					fillOpacity: 0.35,
				});
				this.polygons.setMap(this.map);
				// eslint-disable-next-line no-undef
				const bounds = new google.maps.LatLngBounds();
				for (const poly of this.geofence) {
					// eslint-disable-next-line no-undef
					bounds.extend(new google.maps.LatLng(poly.lat, poly.lng));
				}
				// eslint-disable-next-line no-undef
				const center = new google.maps.Marker({
					position: {
						lat: bounds.getCenter().lat(),
						lng: bounds.getCenter().lng(),
					},
					title: this.placeName,
					icon,
					// eslint-disable-next-line no-undef
					animation: google.maps.Animation.DROP,
				});
				center.setMap(this.map);
				const contentString = `<div style="color: black;" class="title text-capitalize">${this.placeName}</br></div>`;
				// eslint-disable-next-line no-undef
				const infowindow = new google.maps.InfoWindow({
					content: contentString,
				});
				center.addListener('click', () => {
					infowindow.open(this.map, center);
				});
			}
		},
	},
	watch: {
		geofence(newVal) {
			if (newVal.length) this.setPoligon();
		},
	},
};
</script>

<style lang="scss" scoped>
#map {
	color: white;
}
#description {
	font-family: Roboto;
	font-size: 15px;
	font-weight: 300;
}

#infowindow-content .title {
	font-weight: bold;
}

#infowindow-content {
	display: none;
}

#map #infowindow-content {
	display: inline;
}

.pac-card {
	margin: 10px 10px 0 0;
	border-radius: 2px 0 0 2px;
	box-sizing: border-box;
	-moz-box-sizing: border-box;
	outline: none;
	box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
	background-color: #fff;
	font-family: Roboto;
}

#pac-container {
	padding-bottom: 12px;
	margin-right: 12px;
}

.pac-controls {
	display: inline-block;
	padding: 5px 11px;
}

.pac-controls label {
	font-family: Roboto;
	font-size: 13px;
	font-weight: 300;
}

#pac-input {
	background-color: #fff;
	font-family: Roboto;
	font-size: 15px;
	font-weight: 300;
	margin-left: 12px;
	padding: 0 11px 0 13px;
	text-overflow: ellipsis;
	width: 400px;
}

#pac-input:focus {
	border-color: #4d90fe;
}

#title {
	color: #fff;
	background-color: #4d90fe;
	font-size: 25px;
	font-weight: 500;
	padding: 6px 12px;
}

#target {
	width: 345px;
}
</style>
